type Tour3dProps = {
  virtual3DTourProvider: string;
  virtual3DTourId: string;
};

export function Tour3d({
  virtual3DTourProvider,
  virtual3DTourId,
}: Tour3dProps) {
  if (virtual3DTourProvider === 'Zillow') {
    return (
      <div className="size-full">
        <iframe
          title="Virtual 3D Tour"
          className="size-full"
          src={`https://www.zillow.com/view-3d-home/${virtual3DTourId}?setAttribution=mls&wl=true&initialViewType=pano&utm_source=dashboard`}
          allowFullScreen
          allow="vr"
          id="showcase_iframe"
        />
      </div>
    );
  }

  if (virtual3DTourProvider === 'Matterport') {
    return (
      <div className="size-full">
        <iframe
          title="matterport"
          className="size-full"
          src={`https://my.matterport.com/show/?m=${virtual3DTourId}&hhl=0&play=1&tiles=1&brand=0&dh=0&help=0`}
          allowFullScreen
          allow="vr"
          id="showcase_iframe"
        />
      </div>
    );
  }

  return null;
}
